import React from 'react'

import { TabelaColuna } from 'src/componentes'

export const colunaModalidade = (): TabelaColuna => ({
  Chave: 'modalidadePesquisa',
  ComOrdenacao: true,
  RenderizarCabecalho: () => <div style={{ width: 200 }}>Modalidade</div>
})
